import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';
import SavingsIcon from '@mui/icons-material/Savings';
import SpeedIcon from '@mui/icons-material/Speed';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import { Box, Container, Grid, Paper, Typography, useTheme } from '@mui/material';
import { motion } from 'framer-motion';
import React from 'react';

const HELPIGO_BLUE = '#2563eb';

const items = [
    {
        icon: SavingsIcon,
        title: 'Maliyet',
        stat: "%70'e varan",
        body: 'Tekrarlayan soruları otomatik yanıtlayarak müşteri hizmeti yükünü ciddi şekilde azaltın.',
        span: { xs: 12, sm: 6, md: 3 },
    },
    {
        icon: AutoAwesomeIcon,
        title: 'Yapay zeka',
        stat: 'Temsilci kalitesi',
        body: 'Mağaza ve ürün bağlamını kullanan yanıtlar; onay ve puanlama ile güvenli yayın.',
        span: { xs: 12, sm: 6, md: 3 },
    },
    {
        icon: SpeedIcon,
        title: 'Hız',
        stat: 'Saniyeler',
        body: '7/24 kesintisiz ilk yanıt; bekleme sürelerini kısaltıp memnuniyeti yükseltin.',
        span: { xs: 12, sm: 6, md: 3 },
    },
    {
        icon: TrendingUpIcon,
        title: 'Satış',
        stat: "%30'a varan",
        body: 'Hızlı ve tutarlı iletişim, dönüşüm ve tekrar siparişe olumlu katkı sağlar.',
        span: { xs: 12, sm: 6, md: 3 },
    },
];

export default function HomeValueProps() {
    const theme = useTheme();

    return (
        <Box
            component="section"
            sx={{
                py: { xs: 8, md: 11 },
                bgcolor: '#fff',
                borderTop: `1px solid ${theme.palette.grey[100]}`,
            }}
        >
            <Container maxWidth="lg">
                <motion.div
                    initial={{ opacity: 0, y: 16 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.45 }}
                >
                    <Typography
                        variant="overline"
                        sx={{
                            display: 'block',
                            textAlign: 'center',
                            color: HELPIGO_BLUE,
                            fontWeight: 700,
                            letterSpacing: '0.12em',
                            mb: 1,
                        }}
                    >
                        Neden Helpigo
                    </Typography>
                    <Typography
                        variant="h2"
                        component="h2"
                        sx={{
                            textAlign: 'center',
                            fontWeight: 800,
                            fontSize: { xs: '1.85rem', md: '2.5rem' },
                            letterSpacing: '-0.03em',
                            mb: 1.5,
                            color: 'text.primary',
                        }}
                    >
                        Operasyonu sadeleştirin, müşteriyi hızlandırın
                    </Typography>
                    <Typography
                        sx={{
                            textAlign: 'center',
                            color: 'text.secondary',
                            maxWidth: 560,
                            mx: 'auto',
                            mb: { xs: 5, md: 6 },
                            fontSize: { xs: '1rem', md: '1.0625rem' },
                            lineHeight: 1.65,
                        }}
                    >
                        Tek panelden pazaryeri ve mesajlaşma kanallarını yönetin; ekip onayı ve marka dili ile tam kontrol.
                    </Typography>
                </motion.div>

                <Grid container spacing={2.5}>
                    {items.map((item, index) => {
                        const Icon = item.icon;
                        return (
                            <Grid item {...item.span} key={item.title}>
                                <motion.div
                                    initial={{ opacity: 0, y: 20 }}
                                    whileInView={{ opacity: 1, y: 0 }}
                                    viewport={{ once: true }}
                                    transition={{ duration: 0.4, delay: index * 0.06 }}
                                >
                                    <Paper
                                        elevation={0}
                                        sx={{
                                            p: 3,
                                            height: '100%',
                                            borderRadius: 3,
                                            border: `1px solid ${theme.palette.grey[100]}`,
                                            background:
                                                index === 0
                                                    ? `linear-gradient(145deg, rgba(37,99,235,0.06) 0%, #fff 45%)`
                                                    : '#fafbfc',
                                            transition: 'transform 0.2s ease, box-shadow 0.2s ease, border-color 0.2s ease',
                                            '&:hover': {
                                                transform: 'translateY(-4px)',
                                                boxShadow: '0 16px 40px rgba(15, 23, 42, 0.08)',
                                                borderColor: 'rgba(37, 99, 235, 0.2)',
                                                '& .value-icon': { color: HELPIGO_BLUE },
                                            },
                                        }}
                                    >
                                        <Box
                                            className="value-icon"
                                            sx={{
                                                width: 48,
                                                height: 48,
                                                borderRadius: 2,
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                bgcolor: 'rgba(37, 99, 235, 0.1)',
                                                color: HELPIGO_BLUE,
                                                mb: 2,
                                                transition: 'color 0.2s ease',
                                            }}
                                        >
                                            <Icon sx={{ fontSize: 26 }} />
                                        </Box>
                                        <Typography variant="caption" sx={{ color: 'text.secondary', fontWeight: 600 }}>
                                            {item.title}
                                        </Typography>
                                        <Typography variant="h5" sx={{ fontWeight: 800, my: 0.5, letterSpacing: '-0.02em' }}>
                                            {item.stat}
                                        </Typography>
                                        <Typography variant="body2" sx={{ color: 'text.secondary', lineHeight: 1.6 }}>
                                            {item.body}
                                        </Typography>
                                    </Paper>
                                </motion.div>
                            </Grid>
                        );
                    })}
                </Grid>
            </Container>
        </Box>
    );
}
